import { render, staticRenderFns } from "./AdvancedPDFViewer.vue?vue&type=template&id=1c274b91"
import script from "./AdvancedPDFViewer.vue?vue&type=script&lang=js"
export * from "./AdvancedPDFViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports